/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import { Typography } from '@material-ui/core';
import { format as formatDate } from 'date-fns';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import ReportCard from 'components/ReportsModule/components/common/ReportCard';
import LwtTable, { ColumnProps } from 'components/@common/Table/LwtTable';
import { KeyStudentEngagementEnrichmentActivityResult } from 'types/schema-generated-types';

const DATE_FORMAT = 'MM/dd/yyyy';

const getColumns: (t: TFunction) => ColumnProps<any>[] = (t: TFunction) => [
  {
    id: 'dateCompleted',
    label: t('Date'),
    sortKey: 'dateCompleted',
    getValue: item => (
      <Typography>{formatDate(new Date(item.dateCompleted), DATE_FORMAT)}</Typography>
    ),
    sortable: true
  },
  {
    id: 'template',
    label: t('Activity Type'),
    helpText: t('enrichmentActivityType', { ns: 'ReportsHelpTableColumns' }),
    sortKey: 'template',
    getValue: item => <Typography>{t(item.template, { ns: 'KeyActivityTemplates' })}</Typography>,
    sortable: true
  },
  {
    id: 'aborted',
    label: t('Status'),
    helpText: t('activityStatus', { ns: 'ReportsHelpTableColumns' }),
    sortKey: 'aborted',
    getValue: item => <Typography>{item.aborted ? t('Skipped') : t('Completed')}</Typography>,
    sortable: true
  },
  {
    id: 'wpm',
    label: t('Speed (WPM)'),
    helpText: t('wpm', { ns: 'ReportsHelpCommon' }),
    sortKey: 'wpm',
    getValue: item => <Typography>{item.wpm}</Typography>,
    sortable: true
  },
  {
    id: 'accuracy',
    label: t('Accuracy'),
    helpText: t('accuracy', { ns: 'ReportsHelpCommon' }),
    sortKey: 'accuracy',
    getValue: item => <Typography>{item.accuracy}%</Typography>,
    sortable: true
  }
];

const EnrichmentActivityTable: React.FC<{
  reportData?: KeyStudentEngagementEnrichmentActivityResult[];
  loading: boolean;
}> = ({ reportData = [], loading }) => {
  const { t } = useTranslation([
    'Reports',
    'ReportsHelpCommon',
    'ReportsHelpTableColumns',
    'KeyActivityTemplates'
  ]);
  const columns = getColumns(t);

  return (
    <ReportCard title={t('Enrichment Activities')} loading={loading} reportData={reportData}>
      <LwtTable columns={columns} data={reportData} />
    </ReportCard>
  );
};

export default EnrichmentActivityTable;
